import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { ionHomeOutline } from '@ng-icons/ionicons';
import { LanguageSwitcherComponent } from '../../language-switcher/language-switcher.component';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, NgIcon, LanguageSwitcherComponent],
  providers: [provideIcons({ ionHomeOutline })],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent {
  private router = inject(Router);

  goHome() {
    const currentUrl = this.router.url;
    if (currentUrl.includes('/customidp/user')) {
      this.router.navigate(['/customidp/user/login']);
    } else if (currentUrl.includes('/customidp/salesforce')) {
      this.router.navigate(['/customidp/salesforce/login']);
    } else {
      this.router.navigate(['/customidp/salesforce/login']);
    }
  }

  goToLanding() {
    const brandLanding = environment.BRAND_LANDING_URL;
    if (brandLanding && brandLanding.trim() !== '') {
      window.location.href = brandLanding;
    } else {
      this.router.navigate(['/']);
    }
  }
}
